// @flow

import React from 'react';
import { format } from 'date-fns';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';

import { getCity } from '../../helpers';
import useFlightPageContext from '../../static-db';
import { injectFlightSearchParams } from '../../Common';

type OptionProps = {
  queryParams: Object,
};

const formattedDate = date => format(date, 'D MMM, YYYY');

const ModifyOption = (props: OptionProps) => {
  const scrollToRef = React.useRef(null);

  const { queryParams, inbound, outbound } = props;

  if (isEmpty(queryParams)) return null;

  React.useEffect(() => {
    scrollToRef.current.scrollIntoView();
  }, [inbound && outbound]);

  const {
    numAdults,
    numChildren,
    arrivalDate,
    departureDate,
    toLocation,
    fromLocation,
  } = queryParams;

  return (
    <section className="flight__selected__detail" ref={scrollToRef}>
      <div className="flight__info">
        <ul>
          <li className="flight__info_city">
            <City cityCode={fromLocation} />
            <Button color="swap">
              <i className="icon icon-hg-swap-horizontal" />
            </Button>
            <City cityCode={toLocation} />
          </li>
          <li className="flight__info_date">
            <span>
              {formattedDate(departureDate)}{' '}
              {arrivalDate && `- ${formattedDate(arrivalDate)}`}
            </span>
          </li>
          <li className="flight__info_passenger">
            <span>
              {numAdults} {numAdults > 1 ? 'Adults' : 'Adult'} {numChildren}{' '}
              {numChildren > 1 ? 'Children' : 'Child'}
            </span>
          </li>
        </ul>
      </div>
      <div className="flight__action">
        <Button color="yellow-outline" onClick={() => window.scrollTo(100, 0)}>
          MODIFY
        </Button>
      </div>
    </section>
  );
};

const City = ({ cityCode }: { cityCode: string }) => {
  const { sectors } = useFlightPageContext();
  return (
    <span>
      <strong>{cityCode}</strong> {getCity(sectors)(cityCode)}
    </span>
  );
};

const mapStateToProps = ({ flights: { inbound, outbound } }) => ({
  inbound,
  outbound,
});

export default connect(mapStateToProps)(injectFlightSearchParams(ModifyOption));



// WEBPACK FOOTER //
// ./src/screens/Flights/SearchAndResults/SearchResults/ModifyOption.js